import React from "react";
import { Accordion } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { RecekSelect } from "./inputs";
import { AUTHORITY_LINKED_LINKED, AUTHORITY_LINKED_NOT_LINKED, } from "../utils/personAuthorityLink";
/**
 * "Číslo autority NK" register filter (formerly "Napojení na NA") of natural
 * and legal persons: all persons, only those with an NK authority id, or only
 * those without one (DB-635). The help text says what "without" covers.
 */
export var PersonAuthorityLinkedFilter = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Accordion, { label: formatMessage({
            id: "ui-br-agency.person.filter.authorityLinked",
        }), separator: false },
        React.createElement(RecekSelect, { labelId: "ui-br-agency.person.filter.authorityLinked", showLabel: false, value: value, onChange: function (event) {
                return onChange(event.target.value);
            }, fullWidth: true },
            React.createElement("option", { value: "" }, formatMessage({
                id: "ui-br-agency.collectionsList.select.option.all",
            })),
            React.createElement("option", { value: AUTHORITY_LINKED_LINKED }, formatMessage({
                id: "ui-br-agency.person.filter.authorityLinked.linked",
            })),
            React.createElement("option", { value: AUTHORITY_LINKED_NOT_LINKED }, formatMessage({
                id: "ui-br-agency.person.filter.authorityLinked.notLinked",
            })))));
};
